<template>
    <nav aria-label="breadcrumb" class="layout-breadcrumbs text-xs text-placeholder-focus breadcrumbs pt-0 pb-0 h-11 flex ">
        <ol class="breadcrumb" itemscope itemtype="https://schema.org/BreadcrumbList">
            <li>
                <MiscLink no-prefetch to="/" class="text-placeholder-focus">
                    <MiscIcon name="home" size="sm" />
                    <span class="sr-only">{{ t('layout.breadcrumb.homepage') }}</span>
                </MiscLink>
            </li>

            <li
                v-for="(item, id, index) in breadcrumb"
                :key="id"
                itemprop="itemListElement"
                itemscope
                itemtype="https://schema.org/ListItem">
                <div v-if="item.type === 'folder'" itemprop="item">
                    <span itemprop="name" class="font-bold text-link-focus">{{ item.name }}</span>
                </div>

                <MiscLink
                    v-else
                    no-prefetch
                    :to="item.path"
                    :class="index === lastItem ? 'font-bold text-link-focus no-underline hover:underline' : 'text-placeholder-focus underline hover:!no-underline'"
                    itemprop="item"
                >
                    <link itemprop="url" :href="item.path">
                    <span itemprop="name">{{ item.name }}</span>
                </MiscLink>

                <meta itemprop="position" :content="index">
            </li>
        </ol>
    </nav>
</template>

<script setup lang="ts">
import type { HblBreadcrumb } from '@/utils/types'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    breadcrumb: HblBreadcrumb
}>()

const lastItem = computed(() => Object.keys(props?.breadcrumb).length - 1)
</script>
